#import "../fragments/audience-widget-fragment.graphql"

mutation AddAudienceMembership($input: AddEntityToAudienceInput!) {
    addEntityToAudience(input: $input) {
        audienceMembers {
            id
            audience {
                ...AudienceWidgetFragment
            }
        }
    }
}
